import React, { useState } from 'react'

import { formatPosDate, prettyJson } from 'pages/admin/sql/format'

/**
 * Лента команд, которые облако отправляет в канал этой точки.
 *
 * Это ровно тот поток, на который подписана сама касса, — не пересказ из
 * облачной базы. Поэтому вопрос «мы точно отправили?» закрывается здесь, а
 * вопрос «касса точно приняла?» — на вкладке «Чеки». Отправлено, но в базе
 * кассы нет, значит потерялось между ними.
 */

const EVENT_TITLES = {
	'sync.cheque.create': 'Создать чек',
	'sync.cheque.update': 'Изменить чек',
	'sync.cheque.close': 'Закрыть чек',
	'sync.cheque.delete': 'Удалить чек',
	'sync.cheque.print': 'Напечатать чек',
	'sync.cheque.status': 'Статус чека',
	'sync.cheque.address': 'Смена адреса',
	'sync.cheque.courier.status': 'Статус курьера',
	'sync.cheque.payment': 'Оплата',
	'sync.cheque.courier.assign': 'Назначить курьера',
	'sync.cheque.courier.remove': 'Снять курьера',
	'sync.pos.request': 'Синхронизация точки',
	'sync.pos.update': 'Обновить точку',
	'sync.reservation.create': 'Создать бронь',
	'sync.reservation.update': 'Изменить бронь',
	'sync.qr.table': 'QR-меню: действие за столом',
	'sync.qr.order': 'QR-меню: заказ',
}

/** Payload у команд разной формы — вытаскиваем то, что в них общего. */
function summarize(data) {
	if (!data || typeof data !== 'object') return ''

	const source = Array.isArray(data) ? (data[0] || {}) : data
	const parts = []

	const cloudId = source.cloud_id ?? source.cheque_id ?? source.id
	if (cloudId !== undefined && cloudId !== null) parts.push(`чек ${cloudId}`)

	if (source.cheque_number !== undefined && source.cheque_number !== null) {
		parts.push(`№${source.cheque_number}`)
	}
	if (source.status !== undefined && source.status !== null) {
		parts.push(`статус ${source.status}`)
	}
	if (source.external_id) parts.push(`внешний ${source.external_id}`)
	if (source.courier_id) parts.push(`курьер ${source.courier_id}`)
	if (Array.isArray(source.products)) parts.push(`позиций ${source.products.length}`)

	return parts.join(', ')
}

function EventsTab({ monitor }) {
	const [expanded, setExpanded] = useState(null)

	return (
		<div className="card">
			<div className="card-body">
				<div className="d-flex justify-content-between mb-2">
					<div className="text-muted fz14">
						Команды, отправленные облаком в канал точки, с момента подключения.
						Ретроспективы нет: сокет отдаёт только то, что происходит сейчас.
					</div>
					<button type="button" className="btn btn-sm btn-outline-secondary"
						onClick={() => monitor.clearEvents()}>
						Очистить
					</button>
				</div>

				<div className="table-responsive">
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ 'width': '12%' }}>Время</th>
								<th style={{ 'width': '10%' }}>Протокол</th>
								<th style={{ 'width': '25%' }}>Событие</th>
								<th>Кратко</th>
								<th style={{ 'width': '10%' }}></th>
							</tr>
						</thead>
						<tbody>
							{monitor.events.map((event) => (
								<React.Fragment key={event.key}>
									<tr>
										<td className="text-nowrap">{formatPosDate(event.at, 'HH:mm:ss')}</td>
										<td>
											<span className={`badge ${event.protocol === 'sync' ? 'bg-primary' : 'bg-secondary'}`}>
												{event.protocol === 'sync' ? 'sync' : 'legacy'}
											</span>
										</td>
										<td>
											<div>{EVENT_TITLES[event.name] || event.name}</div>
											<div className="text-muted fz12">{event.name}</div>
										</td>
										<td>{summarize(event.data)}</td>
										<td>
											<button type="button" className="btn btn-sm btn-outline-primary"
												onClick={() => setExpanded(expanded === event.key ? null : event.key)}>
												{expanded === event.key ? 'Скрыть' : 'Payload'}
											</button>
										</td>
									</tr>
									{expanded === event.key &&
										<tr>
											<td colSpan="5">
												<pre className="bg-light p-2 fz12 mb-0"
													style={{ 'maxHeight': '400px', 'overflow': 'auto' }}>
													{prettyJson(event.data)}
												</pre>
											</td>
										</tr>
									}
								</React.Fragment>
							))}

							{monitor.events.length === 0 &&
								<tr>
									<td colSpan="5" className="text-center text-muted">
										Пока тихо. Событие появится, как только облако что-нибудь отправит на эту точку.
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

export default EventsTab
